module.exports = __webpack_public_path__ + "2.3184c87e90278cfb68a1.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/bg/2.jpg
// module id = ../../../../../src/assets/images/bg/2.jpg
// module chunks = styles